import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { auth } from './firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import { ToastProvider } from './context/ToastContext';
import { ConfirmProvider } from './context/ConfirmContext';

// Screens
import HomeScreen from './screens/HomeScreen';
import AddRecipeScreen from './screens/AddRecipeScreen';
import RecipeDetailScreen from './screens/RecipeDetailScreen';
import RecipeBookScreen from './screens/RecipeBookScreen';
import LoginScreen from './screens/LoginScreen';
import SharedRecipeScreen from './screens/SharedRecipeScreen';
import FavoritesScreen from './screens/FavoritesScreen';
import PrivacyPolicy from './screens/PrivacyPolicy';
import TermsOfService from './screens/TermsOfService';
import ProfileScreen from './screens/ProfileScreen';
import AdminScreen from './screens/AdminScreen';

// Components
import Navbar from './components/Navbar';
import UpdateNotifier from './components/UpdateNotifier';
import LegalConsentModal from './components/LegalConsentModal';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import Walkthrough from './components/Walkthrough';

function App() {
  const [user, loading] = useAuthState(auth);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen font-body text-on-surface-variant" dir="rtl">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 border-4 border-primary/20 border-t-primary rounded-full animate-spin" />
          <span className="font-medium">טוען...</span>
        </div>
      </div>
    );
  }

  return (
    <ToastProvider>
      <ConfirmProvider>
        <PWAInstallPrompt />
        <Router>
        <Routes>
          {/* --- נתיבים   ציבוריים --- */}
          <Route path="/recipe/:id" element={<SharedRecipeScreen />} />
          <Route path="/privacy"    element={<PrivacyPolicy />} />
          <Route path="/terms"      element={<TermsOfService />} />

          {/* --- ניהול גישה לפי סטטוס התחברות --- */ }
          <Route path="/*" element={
            user ? (
              <div className="bg-background min-h-screen" dir="rtl">
                <LegalConsentModal />
                <Walkthrough />
                <Routes>
                  <Route path="/"          element={<HomeScreen />} />
                  <Route path="/add"       element={<AddRecipeScreen />} />
                  <Route path="/detail"    element={<RecipeDetailScreen />} />
                  <Route path="/book"      element={<RecipeBookScreen />} />
                  <Route path="/favorites" element={<FavoritesScreen />} />
                  <Route path="/profile"   element={<ProfileScreen />} />
                  <Route path="/admin-panel" element={<AdminScreen />} />
                </Routes>
                <Navbar />
                <UpdateNotifier />
              </div>
            ) : (
              <LoginScreen />
            )
          } />
        </Routes>
      </Router>
      </ConfirmProvider>
    </ToastProvider>
  );
}

export default App;
